import React from 'react';
import { useRole } from '../contexts/RoleContext';
import type { UserRole } from '../contexts/RoleContext';

interface RoleGuardProps {
  minimumRole: UserRole;
  children: React.ReactNode;
}

export const RoleGuard: React.FC<RoleGuardProps> = ({ minimumRole, children }) => {
  const { hasMinimumRole, loading } = useRole();

  if (loading) return null;
  if (!hasMinimumRole(minimumRole)) return null;

  return <>{children}</>;
};
